module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1512-35808b22935465b566b99d36f0f65539.png";